import React from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'reactstrap'

import Button from '../../atoms/Button'

const RowStyled = styled(Row)`
  margin-bottom: 60px;
`

const ImageContainer = styled.div`
  border-color: ${({ theme }) => theme.colors.grayContrast};
  border-style: solid;
  border-width: 6px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  max-height: 300px;
  overflow: hidden;
  width: 100%;
`

const Image = styled.img`
  flex: none;
  max-height: 300px;
`

const PublicationTitle = styled.h2`
  color: ${({ theme }) => theme.colors.secondary };
  font-size: 1.35rem;
  font-weight: bold;
  letter-spacing: 0.1rem;
`

const PublicationDetails = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`

const Paragraph = styled.p`
  color: ${({ theme }) => theme.colors.secondary };
  margin-bottom: 32px;
  margin-top: 32px;
  text-align: justify;
`

const Publication = ({ publication }) => (
  <Container>
    <RowStyled>
      <Col xs="3">
        <ImageContainer>
          <Image src={publication.image} />
        </ImageContainer>
      </Col>
      <Col xs="9">
        <PublicationDetails>
          <div>
            <PublicationTitle>
              {publication.title}
            </PublicationTitle>
            <Paragraph>
              {publication.description}
            </Paragraph>
          </div>
          <Button href={publication.link} target="_blank" rel="noopener noreferrer">
            publication.access
          </Button>
        </PublicationDetails>
      </Col>
    </RowStyled>
  </Container>
)

export default Publication



// WEBPACK FOOTER //
// ./src/components/molecules/Publication/Publication.js